<template>
    <div class="v-modal c-questionnaire">
        <div class="v-modal__close" slot="top-right">
            <button class="v-modal__close-button" @click="$emit('close')">
                <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>
            </button>
        </div>
        <div class="v-modal__content">
            <div class="v-popup-content">
                <div ref="content" v-html="content"></div>
                <div v-for="(v, k) in options" class="c-radio c-radio--large">
                    <label class="c-radio__label" :for="k">
                        <input type="radio" :id="k" class="c-radio__input" name="questionnaire" v-model="answer" :value="k">
                        <span class="c-radio__icon"></span>
                        <span class="c-radio__text" v-text="v"></span>
                    </label>
                </div>
                <div class="c-media u-mt-4" v-if="pingBack">
                    <div class="c-media__image">
                        <img :src="managerLogo" style="height: 125px;">
                    </div>
                    <div class="c-media__body">
                        <div class="c-media__title">{{ t('Do you want to talk?') }}</div>
                        <div class="c-radio c-radio--large">
                            <label class="c-radio__label" for="yes">
                                <input type="radio" id="yes" class="c-radio__input" name="ping-back" v-model="contact" :value="true">
                                <span class="c-radio__icon"></span>
                                <span class="c-radio__text">{{ t('Yes, please') }}</span>
                            </label>
                        </div>
                        <div class="c-radio c-radio--large">
                            <label class="c-radio__label" for="no">
                                <input type="radio" id="no" class="c-radio__input" name="ping-back" v-model="contact" :value="false">
                                <span class="c-radio__icon"></span>
                                <span class="c-radio__text">{{ t('No, thanks') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

@Component
    export default class Questionnaire extends BaseComponent {
        @Prop({ type: String, required: true }) protected readonly id: string;

        @Prop({ type: String, required: true }) protected readonly content: string;

        @Prop({ type: Object, required: true }) protected readonly options: { [key: string]: string };

        @Prop({ type: Boolean, required: true }) protected readonly pingBack: boolean;

        @Prop({ type: String, required: true }) protected readonly managerLogo: string;

        private innerAnswer: string | undefined;

        private innerContact: boolean | undefined;

        get answer(): string | undefined {
            return this.innerAnswer;
        }

        set answer(v: string | undefined) {
            this.innerAnswer = v;
            this.complete();
        }

        get contact(): boolean | undefined {
            return this.innerContact;
        }

        set contact(v: boolean | undefined) {
            this.innerContact = v;
            this.complete();
        }

        private complete() {
            EventBus.$emit(this.id, {
                answer: this.innerAnswer,
                contact: this.innerContact,
            });
        }
    }
</script>
